<template>
  <EditarBase
    nomeSingular="FuncionarioPreContratracao"
    nomePlural="FuncionarioPreContratracao"
    @submitSuccess="emitSubmitSuccess"
    @submitError="emitSubmitError"
    @closeModalEdit="closeModalEdit"
  >
    <template v-slot:modals>
      <DialogoDocumentosPreContratacao
        v-model="dialogoDocumentos"
        :pre-contratacao="recurso"
        :dados="dadosImpressao"
      />
    </template>

    <v-col cols="12">
      <v-row>
        <v-col cols="12" md="3">
          <v-text-field
            v-model="recurso.key"
            :label="$t('Chave')"
            name="key"
            disabled
            class="
              input-style
              font-size-input
              text-light-input
              placeholder-light
              input-icon
            "
            dense
            flat
            filled
            solo
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="3">
          <v-text-field
            :value="statusLabel"
            :label="$t('Status')"
            name="status"
            disabled
            class="
              input-style
              font-size-input
              text-light-input
              placeholder-light
              input-icon
            "
            dense
            flat
            filled
            solo
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="3">
          <v-select
            v-model="recurso.statusPreContratracao"
            :items="itensStatusPreContratacao"
            item-text="text"
            item-value="value"
            :label="$t('Status_pre_contratacao')"
            class="
              input-style
              font-size-input
              text-light-input
              placeholder-light
              input-icon
            "
            dense
            flat
            filled
            solo
          ></v-select>
        </v-col>
      </v-row>
    </v-col>

    <v-col cols="12">
      <FormularioFuncionarioPreContratracao
        :recurso="recurso"
        :cidades="cidades"
        :estados="estados"
      />
    </v-col>

    <v-col cols="12">
      <v-expansion-panels multiple>
        <v-expansion-panel>
          <v-expansion-panel-header>{{
            $t("Dados_aprovacao")
          }}</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row>
              <v-col cols="12" md="4">
                <span class="opacity-5 text-dark">
                  {{ $t("Matricula") }}
                </span>
                <v-text-field
                  v-model="recurso.matricula"
                  :label="$t('Matricula')"
                  name="matricula"
                  :disabled="matriculaAutomatica"
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <v-checkbox
                  v-model="matriculaAutomatica"
                  @change="toggleMatriculaAutomatica"
                >
                  <template v-slot:label>
                    {{ $t("Gerar_matricula_automaticamente") }}
                  </template>
                </v-checkbox>
              </v-col>

              <v-col cols="12" md="4">
                <span class="opacity-5 text-dark">
                  {{ $t("Data_de_admissao") }}
                </span>
                <CampoData
                  @date="recurso.admissao = $event"
                  :payload="recurso.admissao"
                  label="Data_de_admissao"
                />
              </v-col>

              <v-col cols="12" md="4">
                <span class="opacity-5 text-dark">
                  {{ $t("Senha") }}
                </span>
                <v-text-field
                  v-model="recurso.senha"
                  :label="$t('Senha')"
                  name="senha"
                  type="password"
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <span class="opacity-5 text-dark">
                  {{ $t("Tipo_de_admissao") }}
                </span>
                <v-select
                  :items="itensTipoAdmissao"
                  :label="$t('Tipo_de_admissao')"
                  v-model="recurso.tipoAdmissao"
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                ></v-select>
              </v-col>

              <v-col cols="12" md="4">
                <span class="opacity-5 text-dark">
                  {{ $t("Tipo_de_jornada") }}
                </span>
                <v-select
                  :items="itensTipoJornada"
                  :label="$t('Tipo_de_jornada')"
                  v-model="recurso.tipoJornada"
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                ></v-select>
              </v-col>

              <v-col cols="12" md="4">
                <span class="opacity-5 text-dark">
                  {{ $t("Salario_base") }}
                </span>
                <v-text-field
                  v-model="salarioBaseDisplay"
                  :label="$t('Salario_base')"
                  name="salarioBase"
                  prefix="R$"
                  class="font-size-input text-light-input placeholder-light"
                  dense
                  flat
                  filled
                  solo
                  clearable
                  :rules="required"
                  inputmode="numeric"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <span class="opacity-5 text-dark">
                  {{ $t("Unidade_de_salario") }}
                </span>
                <v-select
                  :items="itensSalarioUnidade"
                  :label="$t('Unidade_de_salario')"
                  v-model="recurso.salarioUnidade"
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                ></v-select>
              </v-col>

              <v-col cols="12" md="4">
                <span class="opacity-5 text-dark">
                  {{ $t("Tipo_de_contrato") }}
                </span>
                <v-select
                  :items="itensContratoTipo"
                  :label="$t('Tipo_de_contrato')"
                  v-model="recurso.contratoTipo"
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                ></v-select>
              </v-col>

              <v-col cols="12" md="4">
                <span class="opacity-5 text-dark">
                  {{ $t("Data_termino_do_contrato") }}
                </span>
                <CampoData
                  @date="recurso.contratoTermino = $event"
                  :payload="recurso.contratoTermino"
                  label="Data_termino_do_contrato"
                />
              </v-col>

              <v-col
                cols="12"
                md="4"
                v-if="recurso.contratoTipo !== 'INTERMITENTE'"
              >
                <span class="opacity-5 text-dark">
                  {{ $t("Data_de_termino_experiencia1") }}
                </span>
                <CampoData
                  @date="recurso.experienciaTermino1 = $event"
                  :payload="recurso.experienciaTermino1"
                  label="Data_de_termino_experiencia1"
                />
              </v-col>

              <v-col
                cols="12"
                md="4"
                v-if="recurso.contratoTipo !== 'INTERMITENTE'"
              >
                <span class="opacity-5 text-dark">
                  {{ $t("Data_de_termino_experiencia2") }}
                </span>
                <CampoData
                  @date="recurso.experienciaTermino2 = $event"
                  :payload="recurso.experienciaTermino2"
                  label="Data_de_termino_experiencia2"
                />
              </v-col>
            </v-row>

            <v-expansion-panels multiple>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <div class="d-flex align-center">
                    <span>{{ $t("Documentos") }}</span>
                    <v-chip
                      v-if="documentosCount > 0"
                      small
                      class="ml-2"
                      color="primary"
                      text-color="white"
                    >
                      {{ documentosCount }}
                    </v-chip>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-col cols="12">
                      <v-data-table
                        :headers="headersDocumentos"
                        :items="recurso.documentos"
                        :no-data-text="$t('Nenhum_resultado_encontrado')"
                        class="table"
                      >
                        <template v-slot:[`item.documentoUrl`]="{ item }">
                          <v-btn
                            v-if="item.documentoUrl"
                            :href="item.documentoUrl"
                            target="_blank"
                            rel="noopener noreferrer"
                            class="
                              ma-1
                              font-weight-bold
                              text-none
                              btn-primary
                              bg-gradient-primary
                              py-2
                              px-4
                            "
                            height="32"
                          >
                            <v-icon left dark small> mdi-download </v-icon>
                            {{ $t("Download") }}
                          </v-btn>
                          <span v-else>-</span>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel v-if="!ocultarSolicitacaoUniformeContratacao">
                <v-expansion-panel-header>
                  <div class="d-flex align-center">
                    <span>{{ $t("Uniformes") }}</span>
                    <v-chip
                      v-if="uniformesCount > 0"
                      small
                      class="ml-2"
                      color="primary"
                      text-color="white"
                    >
                      {{ uniformesCount }}
                    </v-chip>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-autocomplete
                        v-model="uniformeSelecionado"
                        :items="uniformesDisponiveis"
                        item-text="descricao"
                        return-object
                        :label="$t('Produto')"
                        class="
                          input-style
                          font-size-input
                          text-light-input
                          placeholder-light
                          input-icon
                        "
                        dense
                        flat
                        filled
                        solo
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-text-field
                        v-model.number="uniformeQuantidade"
                        :label="$t('Quantidade_solicitada')"
                        type="number"
                        min="1"
                        class="
                          input-style
                          font-size-input
                          text-light-input
                          placeholder-light
                          input-icon
                        "
                        dense
                        flat
                        filled
                        solo
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="3" class="d-flex align-end">
                      <v-btn
                        class="
                          ma-1
                          font-weight-bold
                          text-none
                          btn-primary
                          bg-gradient-primary
                          py-3
                          px-6
                          ms-3
                        "
                        height="39"
                        :disabled="
                          !uniformeSelecionado ||
                          !uniformeQuantidade ||
                          uniformeQuantidade <= 0
                        "
                        @click="addUniforme"
                      >
                        <v-icon left dark> mdi-plus-circle </v-icon>
                        {{ $t("Adicionar") }}
                      </v-btn>
                    </v-col>
                    <v-col cols="12">
                      <v-data-table
                        :headers="headersUniformes"
                        :items="recurso.uniformes"
                        :no-data-text="$t('Nenhum_resultado_encontrado')"
                        class="table"
                      >
                        <template v-slot:[`item.actions`]="{ item }">
                          <v-icon
                            small
                            @click="removeUniforme(item)"
                            :title="$t('Excluir')"
                            class="mr-2"
                            >ni-fat-remove</v-icon
                          >
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel>
                <v-expansion-panel-header>
                  <div class="d-flex align-center">
                    <span>{{ $t("Convenios") }}</span>
                    <v-chip
                      v-if="conveniosCount > 0"
                      small
                      class="ml-2"
                      color="primary"
                      text-color="white"
                    >
                      {{ conveniosCount }}
                    </v-chip>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-autocomplete
                        v-model="convenioSelecionado"
                        :items="conveniosDisponiveis"
                        item-text="descricao"
                        return-object
                        :label="$t('Convenio')"
                        class="
                          input-style
                          font-size-input
                          text-light-input
                          placeholder-light
                          input-icon
                        "
                        dense
                        flat
                        filled
                        solo
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-text-field
                        v-model.number="convenioQuantidade"
                        :label="$t('quantidadePorApuracao')"
                        type="number"
                        min="0"
                        class="
                          input-style
                          font-size-input
                          text-light-input
                          placeholder-light
                          input-icon
                        "
                        dense
                        flat
                        filled
                        solo
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="3" class="d-flex align-end">
                      <v-btn
                        class="
                          ma-1
                          font-weight-bold
                          text-none
                          btn-primary
                          bg-gradient-primary
                          py-3
                          px-6
                          ms-3
                        "
                        height="39"
                        :disabled="
                          !convenioSelecionado ||
                          convenioQuantidade === null ||
                          convenioQuantidade === undefined ||
                          Number.isNaN(convenioQuantidade)
                        "
                        @click="addConvenio"
                      >
                        <v-icon left dark> mdi-plus-circle </v-icon>
                        {{ $t("Adicionar") }}
                      </v-btn>
                    </v-col>
                    <v-col cols="12">
                      <v-data-table
                        :headers="headersConvenioOptante"
                        :items="recurso.beneficioConvenios"
                        :no-data-text="$t('Nenhum_resultado_encontrado')"
                        class="table"
                      >
                        <template v-slot:[`item.actions`]="{ item }">
                          <v-icon
                            small
                            @click="removeConvenio(item)"
                            :title="$t('Excluir')"
                            class="mr-2"
                            >ni-fat-remove</v-icon
                          >
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>

            <v-expansion-panels multiple>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <div class="d-flex align-center">
                    <span>{{ $t("Dados_da_movimentacao") }}</span>
                    <v-chip
                      v-if="exigeMovimentacao"
                      small
                      class="ml-2"
                      color="primary"
                      text-color="white"
                    >
                      {{ $t("Obrigatorio") }}
                    </v-chip>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-expansion-panels popout>
                    <v-expansion-panel>
                      <v-expansion-panel-header>{{
                        $t("FuncionarioCargo")
                      }}</v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <TabelaSelecionaRecurso
                          :payload="recurso.movimentacao.funcionarioCargo"
                          @recurso="
                            recurso.movimentacao.funcionarioCargo = $event
                          "
                          url="funcionarioCargos/active"
                          cadastro-url="cadastro.FuncionarioCargo"
                          titulo="Cargo"
                          :headers="[
                            {
                              text: $t('Descricao'),
                              value: 'descricao',
                              sortable: false,
                            },
                            {
                              text: $t('Status'),
                              value: 'statusComum',
                              sortable: false,
                            },
                          ]"
                        />
                      </v-expansion-panel-content>
                    </v-expansion-panel>

                    <v-expansion-panel>
                      <v-expansion-panel-header>{{
                        $t("Escala_de_trabalho")
                      }}</v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <TabelaSelecionaRecurso
                          @recurso="
                            recurso.movimentacao.funcionarioEscalaTrabalho =
                              $event
                          "
                          url="funcionarioEscalaTrabalho/active"
                          cadastro-url="cadastro.FuncionarioEscalaTrabalho"
                          titulo="Escala_de_trabalho"
                          :headers="[
                            {
                              text: $t('Descricao'),
                              value: 'descricao',
                              sortable: false,
                            },
                            {
                              text: $t('Escala_intermitente'),
                              value: 'escalaIntermitente',
                              sortable: false,
                            },
                            {
                              text: $t('Carga_horaria'),
                              value: 'jornadaCargaHoraria',
                              sortable: false,
                            },
                            {
                              text: $t('Tipo_apuracao'),
                              value: 'jornadaTipoApuracao',
                              sortable: false,
                            },
                          ]"
                        />
                      </v-expansion-panel-content>
                    </v-expansion-panel>

                    <v-expansion-panel>
                      <v-expansion-panel-header>{{
                        $t("Sindicato")
                      }}</v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <TabelaSelecionaRecurso
                          @recurso="
                            recurso.movimentacao.funcionarioSindicato = $event
                          "
                          url="FuncionarioSindicatos/active"
                          cadastro-url="cadastro.FuncionarioSindicato"
                          titulo="Sindicato"
                          :headers="[
                            {
                              text: $t('Descricao'),
                              value: 'descricao',
                              sortable: false,
                            },
                            {
                              text: $t('Status'),
                              value: 'statusComum',
                              sortable: false,
                            },
                          ]"
                        />
                      </v-expansion-panel-content>
                    </v-expansion-panel>

                    <v-expansion-panel>
                      <v-expansion-panel-header>{{
                        $t("PostoTrabalho")
                      }}</v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <TabelaSelecionaRecurso
                          :payload="recurso.movimentacao.postoTrabalho"
                          @recurso="recurso.movimentacao.postoTrabalho = $event"
                          url="postosTrabalho/active"
                          cadastro-url="cadastro.PostoTrabalho"
                          titulo="PostoTrabalho"
                          :headers="[
                            {
                              text: $t('Descricao'),
                              value: 'descricao',
                              sortable: false,
                            },
                            {
                              text: $t('Status'),
                              value: 'statusComum',
                              sortable: false,
                            },
                          ]"
                        />
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>

            <v-row>
              <v-col cols="12" class="text-right">
                <v-btn
                  v-if="podeImprimirDocumentos"
                  v-can="'ROLE_FuncionarioPreContratracao_Print'"
                  outlined
                  color="primary"
                  class="ma-1 font-weight-bold text-none py-3 px-6 ms-3"
                  height="39"
                  @click="abrirDocumentos"
                >
                  <v-icon left>mdi-printer-outline</v-icon>
                  {{ $t("Imprimir_documentos_admissao") }}
                </v-btn>
                <v-btn
                  class="
                    ma-1
                    font-weight-bold
                    text-none
                    btn-primary
                    bg-gradient-primary
                    py-3
                    px-6
                    ms-3
                  "
                  height="39"
                  :loading="loadingAprovacao"
                  :disabled="loadingAprovacao || !podeAprovar"
                  @click="aprovar"
                >
                  {{ $t("Aprovar") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-col>
  </EditarBase>
</template>

<script>
import EditarBase from "@/components/base/Crud/EditarBase";
import TabelaSelecionaRecurso from "@/components/base/proprios/TabelaSelecionaRecurso";
import FuncionarioDataService from "@/services/pessoal/FuncionarioDataService";
import PreContratacaoDataService from "@/services/pessoal/FuncionarioPreContratracaoDataService";
import FormularioFuncionarioPreContratracao from "./FormularioFuncionarioPreContratracao.vue";
import DialogoDocumentosPreContratacao from "./DialogoDocumentosPreContratacao.vue";
import {
  CAMPOS_OBRIGATORIOS_APROVACAO,
  campoVazio,
  dadosPessoais,
} from "./camposPreContratacao";
import {
  cachedCidades,
  isCachedCidadesValid,
  loadCachedCidades,
} from "@/services/cacheCidades";

export default {
  name: "EditarFuncionarioPreContratracao",
  components: {
    EditarBase,
    TabelaSelecionaRecurso,
    FormularioFuncionarioPreContratracao,
    DialogoDocumentosPreContratacao,
  },
  props: {
    itemAtual: Object,
    // Cargo, posto e salário da vaga da gestão de contratação, usados nos campos vazios da aprovação
    aprovacaoSugerida: { type: Object, default: null },
  },
  data() {
    return {
      DataService: PreContratacaoDataService,
      recurso: {
        dependentes: [],
        uniformes: [],
        beneficioConvenios: [],
        documentos: [],
        movimentacao: {},
      },
      cidades: [],
      estados: [],
      uniformesDisponiveis: [],
      conveniosDisponiveis: [],
      uniformeSelecionado: null,
      uniformeQuantidade: null,
      convenioSelecionado: null,
      convenioQuantidade: null,
      matriculaAutomatica: false,
      salarioBaseDigits: "0",
      loadingAprovacao: false,
      dialogoDocumentos: false,
      dadosImpressao: null,
      itensStatusPreContratacao: [
        { text: this.$t("PENDENTE"), value: "PENDENTE" },
        { text: this.$t("PREENCHIDO"), value: "PREENCHIDO" },
        { text: this.$t("RECUSADA"), value: "RECUSADA" },
      ],
      itensTipoAdmissao: [
        { text: this.$t("Admissao"), value: "ADMISSAO" },
        { text: this.$t("TRANSFEMPGPECON"), value: "TRANSFEMPGPECON" },
        { text: this.$t("TRANSFEMPCONS"), value: "TRANSFEMPCONS" },
        { text: this.$t("TRANSFEMPMOTIVO"), value: "TRANSFEMPMOTIVO" },
        { text: this.$t("MUDANCACPF"), value: "MUDANCACPF" },
      ],
      itensTipoJornada: [
        { text: this.$t("SUBHRTRAB"), value: "SUBHRTRAB" },
        { text: this.$t("ATIVIDADEEXTRA"), value: "ATIVIDADEEXTRA" },
        { text: this.$t("FUNCOESESPEC"), value: "FUNCOESESPEC" },
        { text: this.$t("TELETRABALHO"), value: "TELETRABALHO" },
      ],
      itensSalarioUnidade: [
        { text: this.$t("Por_hora"), value: "PORHORA" },
        { text: this.$t("Por_dia"), value: "PORDIA" },
        { text: this.$t("Por_semana"), value: "PORSEMANA" },
        { text: this.$t("Por_quinzena"), value: "PORQUINZENA" },
        { text: this.$t("Por_mes"), value: "PORMES" },
        { text: this.$t("Por_tarefa"), value: "PORTAREFA" },
        { text: this.$t("Variavel"), value: "VARIAVEL" },
      ],
      itensContratoTipo: [
        { text: this.$t("Prazo_indeterminado"), value: "PRAZOINDETERMINADO" },
        { text: this.$t("PRAZODETERMEMDIAS"), value: "PRAZODETERMEMDIAS" },
        {
          text: this.$t("PRAZODETERMVINCAOCORRENCIA"),
          value: "PRAZODETERMVINCAOCORRENCIA",
        },
        { text: this.$t("INTERMITENTE"), value: "INTERMITENTE" },
      ],
      headersUniformes: [
        {
          text: this.$t("Descricao"),
          value: "produto.descricao",
          align: "start",
          sortable: "false",
        },
        {
          text: this.$t("Tamanho"),
          value: "produto.tamanho",
          align: "start",
          sortable: "false",
        },
        {
          text: this.$t("Quantidade_solicitada"),
          value: "quantidadeSolicitada",
          sortable: "false",
        },
        { text: this.$t("Acoes"), value: "actions", sortable: "false" },
      ],
      headersConvenioOptante: [
        {
          text: this.$t("Convenio"),
          value: "beneficioConvenio.descricao",
          sortable: "false",
        },
        {
          text: this.$t("Tipo"),
          value: "beneficioConvenio.tipo",
          sortable: "false",
        },
        {
          text: this.$t("quantidadePorApuracao"),
          value: "quantidadePorApuracao",
          sortable: "false",
        },
        { text: this.$t("Acoes"), value: "actions", sortable: "false" },
      ],
      headersDocumentos: [
        {
          text: this.$t("Descricao"),
          value: "tipoDocumentoLabel",
          sortable: "false",
        },
        {
          text: this.$t("Arquivo"),
          value: "documentoUrl",
          sortable: "false",
        },
      ],
    };
  },
  computed: {
    statusLabel() {
      return this.recurso && this.recurso.status
        ? this.$t(this.recurso.status)
        : "";
    },
    exigeUniforme() {
      return (
        !this.ocultarSolicitacaoUniformeContratacao &&
        this.parametrizacaoAtiva("CONTRATACAOEXIGIRUNIFORME")
      );
    },
    ocultarSolicitacaoUniformeContratacao() {
      return this.parametrizacaoExiste("UNIFORMEPERMITIRVINCULOPESSOA");
    },
    exigeMovimentacao() {
      return this.parametrizacaoAtiva("CONTRATACAOEXIGIRMOVIMENTACAO");
    },
    podeAprovar() {
      const status = this.recurso && this.recurso.status;
      return status !== "APROVADA" && status !== "RECUSADA";
    },
    podeImprimirDocumentos() {
      return !!this.recurso?.id && this.recurso.status !== "APROVADA";
    },
    salarioBaseDisplay: {
      get() {
        return this.formatCurrencyFromDigits(this.salarioBaseDigits);
      },
      set(value) {
        const digits = this.normalizeDigits(value);
        this.salarioBaseDigits = digits;
        this.recurso.salarioBase = Number(digits) / 100;
      },
    },
    uniformesCount() {
      return Array.isArray(this.recurso?.uniformes)
        ? this.recurso.uniformes.length
        : 0;
    },
    conveniosCount() {
      return Array.isArray(this.recurso?.beneficioConvenios)
        ? this.recurso.beneficioConvenios.length
        : 0;
    },
    documentosCount() {
      return Array.isArray(this.recurso?.documentos)
        ? this.recurso.documentos.length
        : 0;
    },
  },
  mounted() {
    this.loadAuxiliares();
    const id = this.itemAtual?.id || this.$route.params.id;
    if (id) {
      this.getRecurso(id);
    }
  },
  watch: {
    itemAtual: {
      handler(value) {
        if (value && value.id) {
          this.getRecurso(value.id);
        }
      },
      deep: false,
    },
  },
  methods: {
    emitSubmitSuccess(recursoAtualizado = this.recurso) {
      this.$emit("submitSuccess", recursoAtualizado);
    },
    emitSubmitError() {
      this.$emit("submitError");
    },
    closeModalEdit() {
      this.$emit("closeModalEdit");
    },
    loadAuxiliares() {
      FuncionarioDataService.getEstados()
        .then((response) => {
          this.estados = response.data || [];
        })
        .catch(() => {
          this.estados = [];
        });

      if (isCachedCidadesValid()) {
        this.cidades = cachedCidades;
      } else {
        loadCachedCidades(() => FuncionarioDataService.getCidades())
          .then((cidades) => {
            this.cidades = cidades || [];
          })
          .catch(() => {
            this.cidades = [];
          });
      }

      if (!this.ocultarSolicitacaoUniformeContratacao) {
        FuncionarioDataService.getUniformes()
          .then((response) => {
            this.uniformesDisponiveis = response.data || [];
            this.hydrateUniformes();
          })
          .catch(() => {
            this.uniformesDisponiveis = [];
            this.hydrateUniformes();
          });
      }

      FuncionarioDataService.getConvenios()
        .then((response) => {
          this.conveniosDisponiveis = response.data || [];
          this.hydrateConvenios();
        })
        .catch(() => {
          this.conveniosDisponiveis = [];
          this.hydrateConvenios();
        });
    },
    getRecurso(id) {
      PreContratacaoDataService.find(id)
        .then((response) => {
          this.recurso = response.data || {};
          this.normalizeRecurso();
        })
        .catch(() => {
          this.$swal.fire(
            this.$t("Erro"),
            this.$t("Nao_foi_possivel_carregar"),
            "error"
          );
        });
    },
    normalizeRecurso() {
      if (!this.recurso) {
        this.recurso = {};
      }
      if (!Array.isArray(this.recurso.dependentes)) {
        this.$set(this.recurso, "dependentes", []);
      }
      if (!Array.isArray(this.recurso.uniformes)) {
        this.$set(this.recurso, "uniformes", []);
      }
      if (!Array.isArray(this.recurso.beneficioConvenios)) {
        this.$set(this.recurso, "beneficioConvenios", []);
      }
      if (!Array.isArray(this.recurso.documentos)) {
        this.$set(this.recurso, "documentos", []);
      }
      if (!this.recurso.movimentacao) {
        this.$set(this.recurso, "movimentacao", {});
      }
      this.aplicarAprovacaoSugerida();
      const parsedSalarioBase = this.parseDecimalValue(
        this.recurso.salarioBase
      );
      const salarioBaseCents =
        parsedSalarioBase === null ||
        parsedSalarioBase === undefined ||
        Number.isNaN(parsedSalarioBase)
          ? 0
          : Math.round(Number(parsedSalarioBase) * 100);
      this.salarioBaseDigits = String(salarioBaseCents);
      this.recurso.salarioBase = salarioBaseCents / 100;
      this.hydrateUniformes();
      this.hydrateConvenios();
      this.hydrateDocumentos();
      if (!this.recurso.statusPreContratracao && this.recurso.status) {
        this.recurso.statusPreContratracao = this.recurso.status;
      }
      if (this.recurso.matricula === "0" || this.recurso.matricula === 0) {
        this.matriculaAutomatica = true;
      }
    },
    aplicarAprovacaoSugerida() {
      const sugestao = this.aprovacaoSugerida;
      if (!sugestao || this.recurso.status === "APROVADA") {
        return;
      }
      const movimentacao = this.recurso.movimentacao;
      if (sugestao.funcionarioCargo && !movimentacao.funcionarioCargo) {
        this.$set(movimentacao, "funcionarioCargo", sugestao.funcionarioCargo);
      }
      if (sugestao.postoTrabalho && !movimentacao.postoTrabalho) {
        this.$set(movimentacao, "postoTrabalho", sugestao.postoTrabalho);
      }
      if (sugestao.salarioBase && !this.recurso.salarioBase) {
        this.$set(this.recurso, "salarioBase", sugestao.salarioBase);
      }
    },
    toggleMatriculaAutomatica() {
      if (this.matriculaAutomatica) {
        this.recurso.matricula = "0";
      } else if (this.recurso.matricula === "0") {
        this.recurso.matricula = "";
      }
    },
    getProdutoId(item) {
      if (!item) {
        return null;
      }
      const produto = item.produto;
      const id =
        produto?.id || item.produtoId || item.produto_id || item.idProduto;
      return id === null || id === undefined ? null : String(id);
    },
    getConvenioId(item) {
      if (!item) {
        return null;
      }
      const convenio = item.beneficioConvenio;
      const id =
        convenio?.id ||
        item.beneficioConvenioId ||
        item.convenioId ||
        item.beneficioConvenio_id;
      return id === null || id === undefined ? null : String(id);
    },
    addUniforme() {
      if (!this.uniformeSelecionado || !this.uniformeSelecionado.id) {
        this.$swal.fire(
          this.$t("Erro"),
          this.$t("Selecione_um_produto"),
          "error"
        );
        return;
      }
      if (!this.uniformeQuantidade || this.uniformeQuantidade <= 0) {
        this.$swal.fire(
          this.$t("Erro"),
          this.$t("Quantidade_invalida"),
          "error"
        );
        return;
      }
      const uniformes = Array.isArray(this.recurso.uniformes)
        ? [...this.recurso.uniformes]
        : [];
      const selecionadoId = this.getProdutoId({
        produto: this.uniformeSelecionado,
      });
      const existe = uniformes.find(
        (item) => this.getProdutoId(item) === selecionadoId
      );
      if (existe) {
        this.$swal.fire(
          this.$t("Erro"),
          this.$t("Produto_ja_adicionado"),
          "error"
        );
        return;
      }
      uniformes.push({
        produto: this.uniformeSelecionado,
        quantidadeSolicitada: this.uniformeQuantidade,
      });
      this.$set(this.recurso, "uniformes", uniformes);
      this.uniformeSelecionado = null;
      this.uniformeQuantidade = null;
    },
    removeUniforme(item) {
      const produtoId = this.getProdutoId(item);
      if (produtoId) {
        const uniformes = (this.recurso.uniformes || []).filter(
          (uniforme) => this.getProdutoId(uniforme) !== produtoId
        );
        this.$set(this.recurso, "uniformes", uniformes);
        return;
      }
      const uniformes = (this.recurso.uniformes || []).filter(
        (uniforme) => uniforme !== item
      );
      this.$set(this.recurso, "uniformes", uniformes);
    },
    addConvenio() {
      if (!this.convenioSelecionado || !this.convenioSelecionado.id) {
        this.$swal.fire(
          this.$t("Erro"),
          this.$t("Selecione_um_convenio"),
          "error"
        );
        return;
      }
      if (
        this.convenioQuantidade == null ||
        Number.isNaN(this.convenioQuantidade) ||
        this.convenioQuantidade < 0
      ) {
        this.$swal.fire(
          this.$t("Erro"),
          this.$t("Quantidade_invalida"),
          "error"
        );
        return;
      }
      const convenios = Array.isArray(this.recurso.beneficioConvenios)
        ? [...this.recurso.beneficioConvenios]
        : [];
      const selecionadoId = this.getConvenioId({
        beneficioConvenio: this.convenioSelecionado,
      });
      const existe = convenios.find(
        (item) => this.getConvenioId(item) === selecionadoId
      );
      if (existe) {
        this.$swal.fire(
          this.$t("Erro"),
          this.$t("Convenio_ja_adicionado"),
          "error"
        );
        return;
      }
      convenios.push({
        beneficioConvenio: this.convenioSelecionado,
        quantidadePorApuracao: this.convenioQuantidade,
      });
      this.$set(this.recurso, "beneficioConvenios", convenios);
      this.convenioSelecionado = null;
      this.convenioQuantidade = null;
    },
    removeConvenio(item) {
      const convenioId = this.getConvenioId(item);
      if (convenioId) {
        const convenios = (this.recurso.beneficioConvenios || []).filter(
          (beneficio) => this.getConvenioId(beneficio) !== convenioId
        );
        this.$set(this.recurso, "beneficioConvenios", convenios);
        return;
      }
      const convenios = (this.recurso.beneficioConvenios || []).filter(
        (beneficio) => beneficio !== item
      );
      this.$set(this.recurso, "beneficioConvenios", convenios);
    },
    formatCurrencyFromDigits(value) {
      const digits = this.normalizeDigits(value);
      const padded = digits.padStart(3, "0");
      const integerRaw = padded.slice(0, -2);
      const decimalPart = padded.slice(-2);
      let integerPart = integerRaw.replace(/^0+(?=\d)/, "");
      if (!integerPart) {
        integerPart = "0";
      }
      const integerWithSeparator = integerPart.replace(
        /\B(?=(\d{3})+(?!\d))/g,
        "."
      );
      return `${integerWithSeparator},${decimalPart}`;
    },
    normalizeDigits(value) {
      const digits = String(value ?? "").replace(/\D/g, "");
      const trimmed = digits.replace(/^0+(?=\d)/, "");
      return trimmed || "0";
    },
    parseDecimalValue(value) {
      if (value === null || value === undefined || value === "") {
        return null;
      }
      if (typeof value === "number") {
        return value;
      }
      const raw = String(value).trim();
      if (!raw) {
        return null;
      }
      const numericString = raw.replace(/[^0-9.,-]/g, "");
      if (!numericString) {
        return null;
      }
      const lastComma = numericString.lastIndexOf(",");
      const lastDot = numericString.lastIndexOf(".");
      let normalized = numericString;
      if (lastComma > lastDot) {
        normalized = normalized.replace(/\./g, "").replace(",", ".");
      } else if (lastDot > -1) {
        normalized = normalized.replace(/,/g, "");
      }
      const parsed = Number(normalized);
      return Number.isNaN(parsed) ? null : parsed;
    },
    resolveProdutoUniforme(item) {
      if (!item) {
        return null;
      }
      let produto = item.produto;
      if (produto && typeof produto !== "object") {
        produto = { id: produto };
      }
      const produtoId =
        produto?.id || item.produtoId || item.produto_id || item.idProduto;
      if (produtoId) {
        const produtoIdValor = String(produtoId);
        const encontrado = (this.uniformesDisponiveis || []).find(
          (uniforme) => String(uniforme.id) === produtoIdValor
        );
        if (encontrado) {
          produto = { ...encontrado, ...(produto || {}) };
        } else if (!produto || !produto.id) {
          produto = { id: produtoId };
        }
      }
      return produto;
    },
    resolveConvenio(item) {
      if (!item) {
        return null;
      }
      let beneficioConvenio = item.beneficioConvenio;
      if (beneficioConvenio && typeof beneficioConvenio !== "object") {
        beneficioConvenio = { id: beneficioConvenio };
      }
      const convenioId =
        beneficioConvenio?.id ||
        item.beneficioConvenioId ||
        item.convenioId ||
        item.beneficioConvenio_id;
      if (convenioId) {
        const convenioIdValor = String(convenioId);
        const encontrado = (this.conveniosDisponiveis || []).find(
          (convenio) => String(convenio.id) === convenioIdValor
        );
        if (encontrado) {
          beneficioConvenio = { ...encontrado, ...(beneficioConvenio || {}) };
        } else if (!beneficioConvenio || !beneficioConvenio.id) {
          beneficioConvenio = { id: convenioId };
        }
      }
      return beneficioConvenio;
    },
    hydrateUniformes() {
      if (!Array.isArray(this.recurso?.uniformes)) {
        this.$set(this.recurso, "uniformes", []);
        return;
      }
      const uniformes = this.recurso.uniformes
        .map((item) => {
          if (!item) return null;
          const produto = this.resolveProdutoUniforme(item);
          const quantidadeSolicitada =
            item.quantidadeSolicitada ?? item.quantidade ?? null;
          return {
            ...item,
            produto,
            quantidadeSolicitada,
          };
        })
        .filter(Boolean);
      this.$set(this.recurso, "uniformes", uniformes);
    },
    hydrateConvenios() {
      if (!Array.isArray(this.recurso?.beneficioConvenios)) {
        this.$set(this.recurso, "beneficioConvenios", []);
        return;
      }
      const convenios = this.recurso.beneficioConvenios
        .map((item) => {
          if (!item) return null;
          const beneficioConvenio = this.resolveConvenio(item);
          const quantidadePorApuracao =
            item.quantidadePorApuracao ?? item.quantidade ?? null;
          return {
            ...item,
            beneficioConvenio,
            quantidadePorApuracao,
          };
        })
        .filter(Boolean);
      this.$set(this.recurso, "beneficioConvenios", convenios);
    },
    resolveTipoDocumento(item) {
      if (!item) {
        return null;
      }
      let tipoDocumento = item.tipoDocumento;
      if (tipoDocumento && typeof tipoDocumento !== "object") {
        tipoDocumento = { id: tipoDocumento };
      }
      const tipoDocumentoId =
        tipoDocumento?.id ||
        item.tipoDocumentoId ||
        item.tipoDocumento_id ||
        item.idTipoDocumento;
      if (tipoDocumentoId && (!tipoDocumento || !tipoDocumento.id)) {
        tipoDocumento = { id: tipoDocumentoId };
      }
      return tipoDocumento || null;
    },
    hydrateDocumentos() {
      if (!Array.isArray(this.recurso?.documentos)) {
        this.recurso.documentos = [];
        return;
      }
      this.recurso.documentos = this.recurso.documentos
        .map((item) => {
          if (!item) return null;
          const tipoDocumento = this.resolveTipoDocumento(item);
          const tipoDocumentoLabel =
            tipoDocumento?.descricao ||
            tipoDocumento?.nome ||
            item.tipoDocumentoDescricao ||
            item.tipoDocumentoNome ||
            item.descricao ||
            (tipoDocumento?.id ? String(tipoDocumento.id) : "");
          return {
            ...item,
            tipoDocumento,
            tipoDocumentoLabel,
          };
        })
        .filter(Boolean);
    },
    parametrizacaoAtiva(tipo) {
      try {
        const parametrizacoes =
          this.$store?.state?.inquilino?.parametrizacoes || [];
        const parametrizacao = parametrizacoes.find(
          (item) => item?.tipo === tipo
        );
        if (!parametrizacao) return false;
        return parametrizacao.ativo !== false;
      } catch (err) {
        return false;
      }
    },
    parametrizacaoExiste(tipo) {
      const parametrizacoes =
        this.$store?.state?.inquilino?.parametrizacoes || [];
      return parametrizacoes.some((item) => item?.tipo === tipo);
    },
    escapeHtml(value) {
      return String(value)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
    },
    showValidationErrors(errors) {
      const items = errors
        .map((label) => `<li>${this.escapeHtml(label)}</li>`)
        .join("");
      this.$swal.fire({
        title: this.$t("Preencha_todos_os_campos_obrigatorios"),
        html: `<ul>${items}</ul>`,
        icon: "error",
      });
    },
    validateAprovacao() {
      const errors = [];
      const recurso = this.recurso || {};

      // Campos exigidos no cadastro do funcionário: o aprovador completa o que o candidato não informou.
      CAMPOS_OBRIGATORIOS_APROVACAO.forEach(({ campo, label }) => {
        if (campoVazio(recurso[campo])) {
          errors.push(this.$t(label));
        }
      });
      if (!recurso.senha) {
        errors.push(this.$t("Senha"));
      }
      if (!recurso.matricula && recurso.matricula !== "0") {
        errors.push(this.$t("Matricula"));
      }
      if (!recurso.admissao) {
        errors.push(this.$t("Data_de_admissao"));
      }
      if (!recurso.tipoAdmissao) {
        errors.push(this.$t("Tipo_de_admissao"));
      }
      if (!recurso.tipoJornada) {
        errors.push(this.$t("Tipo_de_jornada"));
      }
      if (
        recurso.salarioBase === null ||
        recurso.salarioBase === undefined ||
        recurso.salarioBase === ""
      ) {
        errors.push(this.$t("Salario_base"));
      }
      if (!recurso.salarioUnidade) {
        errors.push(this.$t("Unidade_de_salario"));
      }
      if (!recurso.contratoTipo) {
        errors.push(this.$t("Tipo_de_contrato"));
      }
      // if (!recurso.contratoTermino) {
      //   errors.push(this.$t("Data_termino_do_contrato"));
      // }

      if (recurso.contratoTipo !== "INTERMITENTE") {
        if (!recurso.experienciaTermino1) {
          errors.push(this.$t("Data_de_termino_experiencia1"));
        }
        if (!recurso.experienciaTermino2) {
          errors.push(this.$t("Data_de_termino_experiencia2"));
        }
      }

      if (
        this.exigeUniforme &&
        (!recurso.uniformes || recurso.uniformes.length === 0)
      ) {
        errors.push(this.$t("Uniformes"));
      }

      if (
        !this.ocultarSolicitacaoUniformeContratacao &&
        recurso.uniformes &&
        recurso.uniformes.length > 0
      ) {
        const invalidUniforme = recurso.uniformes.some(
          (item) =>
            !item.produto ||
            !item.produto.id ||
            !item.quantidadeSolicitada ||
            item.quantidadeSolicitada <= 0
        );
        if (invalidUniforme) {
          errors.push(this.$t("Uniformes_incompletos"));
        }
      }

      if (recurso.beneficioConvenios && recurso.beneficioConvenios.length > 0) {
        const invalidConvenio = recurso.beneficioConvenios.some(
          (item) =>
            !item.beneficioConvenio ||
            !item.beneficioConvenio.id ||
            item.quantidadePorApuracao === null ||
            item.quantidadePorApuracao === undefined ||
            Number.isNaN(item.quantidadePorApuracao) ||
            item.quantidadePorApuracao < 0
        );
        if (invalidConvenio) {
          errors.push(this.$t("Convenios_incompletos"));
        }
      }

      if (this.exigeMovimentacao) {
        const mov = recurso.movimentacao || {};
        if (
          !mov.funcionarioCargo?.id ||
          !mov.funcionarioEscalaTrabalho?.id ||
          !mov.funcionarioSindicato?.id ||
          !mov.postoTrabalho?.id
        ) {
          errors.push(this.$t("Movimentacao_incompleta"));
        }
      }

      if (recurso.admissao && recurso.experienciaTermino1) {
        if (
          new Date(recurso.experienciaTermino1) < new Date(recurso.admissao)
        ) {
          errors.push(this.$t("ExperienciaTermino1MaiorAdmissao"));
        }
      }
      if (recurso.experienciaTermino1 && recurso.experienciaTermino2) {
        if (
          new Date(recurso.experienciaTermino2) <
          new Date(recurso.experienciaTermino1)
        ) {
          errors.push(this.$t("ExperienciaTermino2MaiorExperiencia1"));
        }
      }

      if (errors.length > 0) {
        this.showValidationErrors(errors);
        return false;
      }
      return true;
    },
    buildAprovacaoPayload() {
      const payload = {
        ...dadosPessoais(this.recurso),
        id: this.recurso.id,
        matricula: this.recurso.matricula,
        senha: this.recurso.senha,
        admissao: this.recurso.admissao,
        tipoAdmissao: this.recurso.tipoAdmissao,
        tipoJornada: this.recurso.tipoJornada,
        salarioBase: this.recurso.salarioBase,
        salarioUnidade: this.recurso.salarioUnidade,
        contratoTipo: this.recurso.contratoTipo,
        contratoTermino: this.recurso.contratoTermino,
        experienciaTermino1: this.recurso.experienciaTermino1,
        experienciaTermino2: this.recurso.experienciaTermino2,
        uniformes: this.ocultarSolicitacaoUniformeContratacao
          ? []
          : this.recurso.uniformes,
        beneficioConvenios: this.recurso.beneficioConvenios,
        movimentacao: this.recurso.movimentacao,
      };

      if (this.recurso.contratoTipo === "INTERMITENTE") {
        payload.experienciaTermino1 = null;
        payload.experienciaTermino2 = null;
      }

      return payload;
    },
    aprovar() {
      if (!this.validateAprovacao()) {
        return;
      }
      this.loadingAprovacao = true;
      const payload = this.limpaMascara(this.buildAprovacaoPayload());
      PreContratacaoDataService.aprovar(payload)
        .then(() => {
          this.loadingAprovacao = false;
          const aprovadoEm = new Date().toISOString();
          this.recurso.status = "APROVADA";
          this.recurso.statusPreContratracao = "APROVADA";
          this.recurso.dtAprovacao = aprovadoEm;
          if (this.itemAtual) {
            this.itemAtual.status = "APROVADA";
            this.itemAtual.statusPreContratracao = "APROVADA";
            this.itemAtual.dtAprovacao = aprovadoEm;
          }
          this.$swal
            .fire(
              this.$t("Sucesso"),
              this.$t("Aprovado_com_sucesso"),
              "success"
            )
            .then(() => {
              this.closeModalEdit();
            });
        })
        .catch((error) => {
          this.loadingAprovacao = false;
          this.$swal.fire(
            this.$t("Erro"),
            [this.$t("Falha_ao_aprovar"), error?.response?.data?.message]
              .filter(Boolean)
              .join(" "),
            "error"
          );
        });
    },
    abrirDocumentos() {
      this.dadosImpressao = this.limpaMascara(this.buildAprovacaoPayload());
      this.dialogoDocumentos = true;
    },
  },
};
</script>

<style scoped></style>
